"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import cx from "classnames";
import Image from "@ingka/image";
import AspectRatioBox from "@ingka/aspect-ratio-box";
import PaymentLogo from "@ingka/payment-logo";
import Collapsible from "@ingka/collapsible";
import SSRIcon from "@ingka/ssr-icon";
const ChoiceItem = (props) => {
  const {
    id,
    className,
    ssrIcon,
    customContent,
    children,
    addOn,
    disabled,
    subtle,
    size,
    imageAlignment = "center",
    valueAlignment = "top",
    href,
    image,
    imagePosition = "leading",
    paymentLogo,
    onClick = () => {
    },
    selected,
    prefix = "",
    caption,
    title,
    value,
    controlProps,
    ...other
  } = props;
  const baseClass = `${prefix}choice-item`;
  const classes = cx(
    baseClass,
    selected && `${baseClass}--selected`,
    subtle && `${baseClass}--subtle`,
    imagePosition === "trailing" && `${baseClass}--trailing-image`,
    className
  );
  const ChoiceAction = href ? "a" : "button";
  const choiceContent = /* @__PURE__ */ jsxs("span", { className: `${baseClass}__content`, children: [
    /* @__PURE__ */ jsxs("span", { className: `${baseClass}__text`, children: [
      /* @__PURE__ */ jsx("span", { className: `${baseClass}__title`, children: title }),
      caption && /* @__PURE__ */ jsx("span", { className: `${baseClass}__caption`, children: caption }),
      addOn && /* @__PURE__ */ jsx("span", { className: `${baseClass}__addon`, children: addOn })
    ] }),
    imagePosition !== "trailing" && /* @__PURE__ */ jsx("span", { className: `${baseClass}__values`, children: value && /* @__PURE__ */ jsx(
      "span",
      {
        className: valueAlignment === "center" && caption ? `${baseClass}__value ${baseClass}__value--center` : `${baseClass}__value`,
        children: value
      }
    ) })
  ] });
  return /* @__PURE__ */ jsxs("div", { ...other, id, className: classes, children: [
    /* @__PURE__ */ jsxs(
      ChoiceAction,
      {
        href,
        type: !href ? "button" : void 0,
        rel: href && "noopener noreferrer",
        "aria-pressed": !href && selected,
        className: imageAlignment === "top" && caption ? `${baseClass}__action ${baseClass}__action--top` : `${baseClass}__action`,
        disabled,
        onClick: () => onClick(id),
        ...controlProps,
        children: [
          ssrIcon && !image && !paymentLogo && /* @__PURE__ */ jsx(
            SSRIcon,
            {
              prefix,
              className: `${baseClass}__icon`,
              paths: ssrIcon
            }
          ),
          paymentLogo && !image && /* @__PURE__ */ jsx(
            PaymentLogo,
            {
              size: size === "small" ? "small" : "medium",
              src: paymentLogo.src,
              alt: paymentLogo.alt,
              prefix,
              className: `${baseClass}__payment-logo`
            }
          ),
          image && /* @__PURE__ */ jsx("span", { className: `${baseClass}__image`, children: /* @__PURE__ */ jsx(AspectRatioBox, { ratio: "square", prefix, children: /* @__PURE__ */ jsx(Image, { prefix, ...image }) }) }),
          customContent ? /* @__PURE__ */ jsx("span", { className: `${baseClass}__custom-content`, children: customContent }) : choiceContent
        ]
      }
    ),
    /* @__PURE__ */ jsx("span", { className: `${baseClass}__border`, "aria-hidden": "true" }),
    children && /* @__PURE__ */ jsx(
      Collapsible,
      {
        prefix,
        id: `${id}-collapsible`,
        expanded: !!(children && selected && !disabled),
        children: /* @__PURE__ */ jsx("div", { className: `${baseClass}__nested`, children })
      }
    )
  ] });
};
var ChoiceItem_default = ChoiceItem;
export {
  ChoiceItem,
  ChoiceItem_default as default
};
